import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'

const axios = require("axios")
axios.apiv1 = axios.create({ baseURL: "/web-api" })

window._ = require('lodash')
window.axios = axios

Vue.use(Vuex)

import button from './athoms/Button.vue'
import searchglobal from './athoms/Megasearch/searchglobal.vue'
// import searchtag from './athoms/Megasearch/Searchtag.vue'
import input from './athoms/Input.vue'
import form_messages from './pages/forms/sendMessages.vue'
import pagination from './athoms/pagination.vue'
import checkbox from './athoms/Checkbox.vue'
import langToast from './athoms/langToast.vue'
import change_lang from './athoms/change_lang.vue'
import preloader from './athoms/preloader.vue'
import form_reg_and_log from './pages/forms/form_reg_and_log.vue'
import manufacturers_count from './components/manufacturer/manufacturers_count'
import our_models_count from './components/manufacturer/our_models_count'
import StatNumber from './components/portal-statistic/stat-number.vue'

Vue.component('stat_number', StatNumber)
Vue.component('our_models_count', our_models_count)
Vue.component('manufacturers_count', manufacturers_count)
Vue.component('v-btn', button)
Vue.component('searchglobal', searchglobal)
// Vue.component('searchtag', searchtag)
Vue.component('v-input', input)
Vue.component('formmessages', form_messages)
Vue.component('pagination', pagination)
Vue.component('v-checkbox', checkbox)
Vue.component('langToast', langToast)
Vue.component('changelang', change_lang)
Vue.component('preloader', preloader)
Vue.component('formregandlog', form_reg_and_log)

// Фильтры =======================

// Деление числа на разряды
import discharge from './filters/discharge.filter'
Vue.filter('discharge', discharge)

// Склонения слов
import declOfNum from './filters/declOfNum.filter'
Vue.filter('declOfNum', declOfNum)


// Парсинг массива под формат селекта
import selectParse from './utils/selectParse'
Vue.use(selectParse)

// Деление числа на разряды
import dateFilter from './filters/date.filter'
Vue.filter('date', dateFilter)

// Удаляет у тегов атрибут style
import htmlFilter from './filters/clearHTML.filter'
Vue.filter('removeAttrs', htmlFilter)

// Удаляет середину строки
import cutString from './filters/cutString.filter'
Vue.filter('cut', cutString)

// Парсит номера телефонов в нужный формат
import phoneFormat from './filters/phoneFormatting.filter'
Vue.filter('phoneFormat', phoneFormat)

import strippedUrl from './filters/strippedUrl.filter'
Vue.filter('strippedUrl', strippedUrl)

// Формирует номер телефона для ссылки href="tel:{phone}"
import linkPhoneFormat from './filters/linkPhoneFormatting.filter'
Vue.filter('linkPhoneFormat', linkPhoneFormat)

// Миксины ================

// Вычисляет ширину экрана
import breakpoint from './mixins/breakpoint'
Vue.mixin(breakpoint);

// Сторонние плагины ================
import 'es6-promise/auto'

// библиотека компонентов
import BimlibComponents from '@bimlib/components'
import bimButton from '@bimlib/components/bimButton'
import bimTextMain from '@bimlib/components/bimTextMain'
import bimText from '@bimlib/components/bimText'

Vue.use(BimlibComponents)
Vue.component('bimButton', bimButton)
Vue.component('bimTextMain', bimTextMain)
Vue.component('bimText', bimText)

// https://github.com/Akryum/v-tooltip
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

// Мультиселект https://vue-multiselect.js.org
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// Noty https://github.com/renoguyon/vuejs-noty
import VueNoty from 'vuejs-noty'
Vue.use(VueNoty)


// Настройки проекта  ================

// Переводы
import vuexI18n from 'vuex-i18n'
import translationsEn from './i18n/en.js'
import translationsRu from './i18n/ru.js'

Vue.use(vuexI18n.plugin, store, {
    moduleName: 'i18n',
    onTranslationNotFound(locale, key) {
      return key;
    }
  },
)

// add translations
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('ru', translationsRu)
// default locale is english
const language = localStorage.getItem('_user_language_')
if (language) {
  Vue.i18n.set(language)
} else {
  Vue.i18n.set('ru')
}

// Валидатор форм
const dictionary = {
  ru: {
    messages: {
      confirmed: (field, e) => `Поле ${field} не совпадает с полем ${e[0]}.`
    },
  },
}
import ru from 'vee-validate/dist/locale/ru'
import VeeValidate, { Validator } from 'vee-validate'

Validator.localize('ru', ru) // здесь происходит изменение локали
Validator.localize('ru', dictionary.ru) // здесь происходит изменение сообщений об ошибках
Vue.use(VeeValidate, { locale: 'ru' })
import bimHeader from '@bimlib/components/bimHeader'
import bimFooter from '@bimlib/components/bimFooter'
import ChangeLang from './athoms/change_lang'
import Config from './config'
import { setCookie } from './utils/cookie'

import { metricDirective } from './utils/metric.directive'
Vue.directive('metric', metricDirective)

import { YMGoalTelegramClick } from './utils/yandexMetricGoals'
import logActionEvent from './utils/logActionEvent'

import Carrot from './utils/carrot'
Vue.use(Carrot)

const app = new Vue({
  store,
  el: '#app',
  delimiters: ['${', '}'],
  data() {
    return {
      user: null,
    }
  },
  async mounted () {
    await this.verifyUserContext()

    this.socialShare()
    this.renderFooter()
    this.renderHeader()

    this.saveUtmParams()

    // Запрос динамических данных
    this.$store.dispatch('counters/fetchCounters')
  },
  methods: {

    // сохраним utm метки
    saveUtmParams() {
      const params = new URLSearchParams(window.location.search)
      const iter = new Map(params.entries())
      const objectQueryParams = [...iter].reduce((obj, [key, value]) => {
        obj[key] = value
        return obj
      }, {})

      const keys = []

      for(var key in objectQueryParams) {
        if (objectQueryParams.hasOwnProperty(key)) {
          if (~String(key).indexOf('utm_')) {
            keys.push(`${key}=${objectQueryParams[key]}`)
          }
        }
      }

      if (keys.length) {
        const options = {
          path: '/',
          expires: 60 * 60 * 24 * 30
        }

        setCookie('utm-tags', keys.join('&'), options)
      }
    },

    // проверим контекст пользователя
    async verifyUserContext() {

      // проверим авторизованы ли мы в auth сервисе
      const verifyAuthorized = async () => {
        try {
          const isAuthorized = await this.$user.isAuthorized(Config.appEnv)

          // авторизованы - можно автоматически залогиниться
          if (isAuthorized) {
            this.openLoginPage()
          }
        } catch (e) {
          console.error('catch isAuthorized')
        }
      }

      try {
        this.user = await this.$user.fetchContextWithRedirect()
        localStorage.setItem('UUID', this.user.id)
      // не удалось получить данные пользователя
      } catch (e) {
        await verifyAuthorized()
      }
    },

    // открыть страницу авторизации
    openLoginPage() {
      this.$user.openLoginPage('web', Config.appEnv)
    },

    // выход
    async logoutUser() {
      try {
        await this.$user.logoutUser(Config.appEnv)
      } catch (e) {

      } finally {
        window.location.reload()
      }
    },

    async renderHeader () {
      const headerEl = document.querySelector('#js-library-header')
      if (!headerEl) return

      new Vue({
        render: h => h(bimHeader, {
          on: {
            loginClicked: ( ) => {
              this.$user.openLoginPage('web', Config.appEnv)
            },
            changeLanguage: this.onChangeLanguage.bind(this),
            userMenuClicked: item => {
              const logout = this.logoutUser.bind(this)
              switch (item) {
                case "home":
                  window.location.assign(Config.lkURL); break;
                case "messages":
                  window.location.assign(Config.lkURL+"/messages/"); break;
                case "models":
                  window.location.assign(Config.lkURL+"/models/"); break;
                case "statistic":
                  window.location.assign(Config.lkURL+"/statistic/users/"); break;
                case "logout":
                  logout(); break;
                default: break;
              }
            }
          },
          props: {
            user: this.user,
            makeSearch: false,
            activeLang: this.$store.state.i18n.locale,
            logActionEvent: this.$logActionEvent,
            showNotices: true,
          },
        }),
      }).$mount(headerEl)
    },

    renderFooter () {
      const footerEl = document.querySelector('#js-library-footer')

      if (!footerEl) {
        return
      }

      new Vue({
        store: this.$store,
        render: h => h(bimFooter, {
          on: {
            changeLanguage: this.onChangeLanguage.bind(this),
            footerButtonClick(button) {
              if (button.specialButton === 'telegram') {
                YMGoalTelegramClick()
              }
            },
            socialLinkClick(name) {
              if (name === 'telegram') {
                YMGoalTelegramClick()
              }
            }
          },
          props: {
            activeLang: this.$store.state.i18n.locale,
            showEmailNewsletter: true,
            callbackSendEmail: async (email) => {
              try {
                const res = await axios.apiv1.get(`/mails/subscribe/${email}`)

                await this.$carrot.track('Подписка на рассылку', { email })

                return res
              } catch (e) {
                console.error(e)
              }
            }
          }
        }),
      }).$mount(footerEl)
    },
    onChangeLanguage (lang) {
      // init lang
      const changeLang = Vue.extend(ChangeLang)

      const langClass = new changeLang({ store: this.$store })

      langClass.setCookies(lang)
    },
    /**
     * Социалки для ЧЗ
     */
    socialShare () {
      const shareButtonList = document.querySelectorAll('.social-share')
      if (shareButtonList) {
        for (let i = 0; i < shareButtonList.length; i++) {
          shareButtonList[i].addEventListener('click', function () {
            let ogTitle
            if (document.querySelector('meta[property="og:title"]')) {
              ogTitle = document.querySelector('meta[property="og:title"]').getAttribute('content')
            } else {
              ogTitle = 'BIMLIB'
            }

            let ogImg
            if (document.querySelector('meta[property="og:image"]')) {
              ogImg = document.querySelector('meta[property="og:image"]').getAttribute('content')
            } else {
              ogImg = 'https://bimlib.pro' + document.querySelector('link[rel="apple-touch-icon"]').getAttribute('href')
            }

            if (this.getAttribute('data-social') === 'vk') {
              window.open('https://vk.com/share.php?url=' + window.location.href + '&title=' + ogTitle + '&image=' + ogImg + '&description=&noparse=true', 'share', 'width=600,height=400')
            }

            if (this.getAttribute('data-social') === 'fb') {
              window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href + '&title=' + ogTitle + '&image=' + ogImg + '&description=&noparse=true', 'share', 'width=600,height=400')
            }

            if (this.getAttribute('data-social') === 'tw') {
              window.open('https://twitter.com/share?url=' + window.location.href + '&title=' + ogTitle + '&image=' + ogImg + '&description=&noparse=true', 'share', 'width=600,height=400')
            }
          })
        }
      }
    },
  },
})

Vue.prototype.$logActionEvent = logActionEvent.bind(app)

/**
 * Опрос проектировщиков
 */
import { showDesignerForm } from './utils/quiz_forms/designer_quiz'
showDesignerForm(app)

window.app = app
